import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";
import BenefitPeriod from "../components/BenefitPeriod";

import "./randingStyle29.scss";
import PrivacyContent from "./PrivacyContent";
import RandingConsent from "./RandingConsent";

function RandingStyle29({
  urlCode,
  urlCodeSettingId,
  topImg,
  topCallIconImg,
  callIconImg,
  img1Path,
  postBTN,
  companyName,
  footerPath,
  apiUrl,
  privacyMessage,
  kakaotalk,
  carrotTag,
  customFooter,
  footerData,
  footerStyle,
  callNumber,
}) {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  const phoneSecondRef = useRef(null);
  const phoneThirdRef = useRef(null);

  const validateInput = () =>
    validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber);

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption: "",
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  const displayNumber = callNumber || "0507-1381-8528";
  const telNumber = displayNumber.replace(/-/g, "");

  const handleCallClick = () => {
    if (urlCodeSettingId) {
      fetch(
        `https://funnelsolution.co.kr/api/urlcode/request-count/${encodeURIComponent(urlCodeSettingId)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then(() => console.log("[508] 전화 클릭 - request count 증가 완료"))
        .catch((err) => console.error("[508] request count 증가 실패:", err));
    }
  };

  return (
    <div className="form-container randing-style-29">

      {/* 상단 인콜 버튼 */}
      {topImg && (
        <div className="top-call-wrapper">
          <div style={{ position: "relative", width: "100%" }}>
            <img src={topImg} alt="검단뉴욕치과 아라역 1번 출구 도보 4분" style={{ width: "100%", display: "block" }} />
            {callIconImg && (
              <a href={`tel:${telNumber}`} className="call-button" onClick={handleCallClick}>
                <img src={callIconImg} alt="전화하기" />
              </a>
            )}
          </div>
        </div>
      )}

      {/* 통이미지 */}
      <div className="main-image-wrapper">
        <img src={img1Path} alt="돌출입, 덧니 고민이셨나요? 설문 참여 시 치아교정 최저가 월 10만원" />
        {topCallIconImg && (
          <a href={`tel:${telNumber}`} className="call-button" onClick={handleCallClick}>
            <img src={topCallIconImg} alt="전화하기" />
          </a>
        )}
        {callIconImg && (
          <a href={`tel:${telNumber}`} className="bottom-call-button" onClick={handleCallClick}>
            <img src={callIconImg} alt="전화하기" />
          </a>
        )}
      </div>

      {/* 폼 영역 */}
      <div className="form-area">
        <div className="benefitDate">
          <BenefitPeriod periodType="month" />
        </div>

        <form
          id="randing-style-29-form"
          className="simple-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="input-wrap">
            <div className="input-user">
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                placeholder="입력*"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="input-contact">
              <label>연락처</label>
              <div className="phone-wrap">
                <input
                  type="tel"
                  placeholder="010"
                  maxLength="3"
                  value="010"
                  readOnly
                />
                <input
                  ref={phoneSecondRef}
                  type="tel"
                  placeholder="0000"
                  maxLength="4"
                  value={phoneNumber.second}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                    setPhoneNumber((prev) => ({ ...prev, first: "010", second: val }));
                    if (val.length === 4) phoneThirdRef.current?.focus();
                  }}
                  required
                />
                <input
                  ref={phoneThirdRef}
                  type="tel"
                  placeholder="0000"
                  maxLength="4"
                  value={phoneNumber.third}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                    setPhoneNumber((prev) => ({ ...prev, first: "010", third: val }));
                  }}
                  required
                />
              </div>
            </div>
          </div>
        </form>

        <RandingConsent
          isAgreed={isAgreed}
          setIsAgreed={setIsAgreed}
          isMarketingAgreed={isMarketingAgreed}
          setIsMarketingAgreed={setIsMarketingAgreed}
          privacyContent={<PrivacyContent companyName={companyName} />}
          companyName={companyName}
        />
      </div>

      {/* 푸터 */}
      <div className="footer" style={footerStyle}>
        {customFooter && footerData ? (
          <div className="custom-footer">
            <p className="footer-line1">{footerData.line1}</p>
            <p className="footer-line2">{footerData.line2}</p>
            <p className="footer-line3">{footerData.line3}</p>
          </div>
        ) : (
          footerPath && <img src={footerPath} alt="푸터" />
        )}
      </div>

      {/* 하단 고정 신청하기 버튼 */}
      <button
        id="postBtn"
        type="submit"
        form="randing-style-29-form"
        className="postBtn postBtn-fixed"
        disabled={isSubmitting}
      >
        <img src={postBTN} alt="신청하기" />
      </button>
    </div>
  );
}

export default RandingStyle29;
